/**
 * Formata uma data - 0000-00-00 -> 00/00/0000
 * @param {String} date - Data 0000-00-00
 */
export function format(date) {
  try {
    const parts = date.split("-");

    return `${parts[2]}/${parts[1]}/${parts[0]}`;
  } catch (error) {
    return "";
  }
}

/**
 * Formata uma data - 00/00/0000 -> 0000-00-00
 * @param {String} date
 */
export function formatReverse(date) {
  try {
    const parts = date.split("/");

    return `${parts[2]}-${parts[1]}-${parts[0]}`;
  } catch (error) {
    return "";
  }
}

/**
 * Retorna um objeto Date de uma string
 * @param {String} stringdate - Data no formato 0000-00-00 ou 00/00/0000
 * @return {Date}
 */
export function toDate(stringdate) {
  const date = new Date();

  let day = 0;
  let month = 0;
  let year = 0;

  if (stringdate.indexOf("-") != -1) {
    let parts = stringdate.split("-");
    day = parseInt(parts[2]);
    month = parseInt(parts[1]);
    year = parseInt(parts[0]);
  }
  if (stringdate.indexOf("/") != -1) {
    let parts = stringdate.split("/");
    day = parseInt(parts[0]);
    month = parseInt(parts[1]);
    year = parseInt(parts[2]);
  }

  if (day == 0 && month == 0 && year == 0) return null;

  date.setDate(day);
  date.setMonth(month - 1);
  date.setFullYear(year);

  return date;
}



// WEBPACK FOOTER //
// ./src/utils/DateFormater.js